import http from './http'


const prefix = '/store'

export function getProductList() {
  let url = prefix + "/product/"
  return http.get(url, {})
}


export function getCoupon(couponid) {
  let url = prefix + "/coupon/"+couponid
  return http.get(url, {})
}


export function getSKUList(productid) {
  let url = prefix + "/product/"+productid
  return http.get(url, {})
}

export function submitNewOrder(object) {
  let url = prefix + "/order"
  return http.post(url, object, {})
}

export function submitOrderInfo(object) {
  let url = prefix + "/order/info"
  return http.post(url, object, {})
}

export function promotionSignup(object) {
  let url = prefix + "/promotionsignup"
  return http.post(url, object, {})
}

export function sendEmailReceipt(stripe_order_id, object) {
  let url = prefix + "/order/receipt"
  if(stripe_order_id!=null){
    url = url +'/'+stripe_order_id
  }else{
    url = url +'/'+'paypal'
  }
  return http.post(url, object, {})
}

export function captureOrder(orderid, sourceid) {
  let url = prefix + "/order/"+orderid+"/capture/"+sourceid;
  return http.post(url, {}, {})
}

export function captureOrderToken(object, sourceid) {
  let url = prefix + "/order/source/"+sourceid;
  return http.post(url, object, {})
}


export function tokenize(object) {
  let url = "https://api.stripe.com/v1/tokens";
  return http.post(url, object, {})
}

export function getReviews(key, lastkey) {
  let url = prefix + "/review/"
  if(key!=null){
    url +=  key +"/5"
  }
  if(lastkey!=null){
    url += "?lastkey_reviewid="+lastkey.reviewid.s+"&lastkey_createdtime="+encodeURI(lastkey.createdtime.s);
  }
  return http.get(url, {})
}

export function postReview(review) {
  let url = prefix + "/review/"
  return http.post(url, review, {})
}